/* CHYRONYX — FAQ Accordion (replaces Radix AccordionItem) */
(function(){
  document.querySelectorAll('.faq-question').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.faq-item');
      var wasOpen = item.classList.contains('open');
      // Close all siblings
      item.parentElement.querySelectorAll('.faq-item.open').forEach(function(el){
        el.classList.remove('open');
      });
      // Toggle current
      if (!wasOpen) item.classList.add('open');
    });
  });
})();
